import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirEjecucionMensualPartidasdCuentas = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [report, setReport] = useState('');
    const [fecha, setFecha] = useState('');
    const [parameter, setParameter] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtFecha = useRef();
    const txtCheck = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtFecha.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Fecha!', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        }

        else if (sigue) {
            imprimirGeneral(fecha, parameter)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'fecha') {
            setFecha(e.target.value);
            setActivo(false);
        }
    };

    const onCheck = () => {

        if (txtCheck.current.checked === true) {

            if (props.condicion === 'Nivel Partidas de Cuentas' || props.condicion === 'Disponibilidad del Periodo General') {
                setParameter("alcaldia = true");
            } else {
                setParameter("CAT.alcaldia = true");
            }

        } else if (txtCheck.current.checked === false) {
            setParameter("TRUE");
        }

    }

    const imprimirGeneral = (fecha, val) => {

        let fech = moment.utc(fecha).format('DD-MM-YYYY');
        var reporte = "";
        var valida;
        var condicionc;
        let condi = "al Día" + " " + "'" + fech + "'";
        let nivel = 0;
        var validar = 1;

        if (val === "TRUE") {
            valida = "TRUE";
        } else {
            valida = parameter;
        }

        if (props.condicion === 'Nivel Partidas de Cuentas') {
            reporte = "Pres_SE_EjecucionGtosMes";
            validar = 2;
        } else if (props.condicion === 'Disponibilidad del Periodo General') {
            reporte = "Pres_SE_EjecucionDispPart";
            validar = 3;
        } else if (props.condicion === 'Sectores') {
            reporte = "Pres_CAT_EjecucionGtosMes";
            nivel = 1;
            validar = 1;
            condicionc = "Fecha<=" + "'" + fech + "'";
        } else if (props.condicion === 'Programas') {
            reporte = "Pres_CAT_EjecucionGtosMes";
            nivel = 2;
            validar = 1;
            condicionc = "Fecha<=" + "'" + fech + "'";
        } else if (props.condicion === 'Sub-Programas') {
            reporte = "Pres_CAT_EjecucionGtosMes";
            nivel = 3;
            validar = 1;
            condicionc = "Fecha<=" + "'" + fech + "'";
        } else if (props.condicion === 'Proyectos') {
            reporte = "Pres_CAT_EjecucionGtosMes";
            nivel = 4;
            validar = 1;
            condicionc = "Fecha<=" + "'" + fech + "'";
        } else if (props.condicion === 'Actividad') {
            reporte = "Pres_CAT_EjecucionGtosMes";
            nivel = 5;
            validar = 1;
            condicionc = "Fecha<=" + "'" + fech + "'";
        }

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + valida + "&sql3=" + fech + "&sql4=" + condi + "&sql5=" + condicionc + "&nivel=" + nivel + "&val=" + validar, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtFecha.current.value = '';
        setActivo(true);
        setParameter("");
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lx"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtFecha.current.value = fech;
                setFecha(fech);
                setParameter("TRUE");
                if (fech !== '') {
                    setActivo(false);
                } else {
                    setActivo(true);
                }
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir' + ' ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-6 mb-1 px-1'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Al Día:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtFecha} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="fecha" />
                                        </div>
                                    </div>

                                    <div className='col-sm-5 mb-1 ml-auto'>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" ref={txtCheck} onChange={onCheck} type="checkbox" id="inlineCheckbox1" value="option1" />
                                            <label className="form-check-label" for="inlineCheckbox1">Solo Alcaldía</label>
                                        </div>
                                    </div>

                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}